import type { ObservationCommentsProps } from "./observation-comments.type";

import { useScroll } from "@/hooks/useScroll";
import ObservationCommentForm from "@/modules/observation/observation-comment-form";
import ObservationCommentsList from "@/modules/observation/observation-comments-list";

import "./observation-comments.style.less";

export const ObservationComments = ({
  observation,
}: ObservationCommentsProps) => {
  const { scrollableRef, scrollTo } = useScroll();

  // Scroll back to top of div to see latest create comment
  const onSuccess = () => scrollTo({ top: 0 });

  return (
    <div className="observation-comments" ref={scrollableRef}>
      <ObservationCommentForm observation={observation} onSuccess={onSuccess} />
      <ObservationCommentsList observation={observation} />
    </div>
  );
};
